export { default } from './forEachRight.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/eachRight.js
// module id = 627
// module chunks = 67